// extracted by mini-css-extract-plugin
var _1 = "M9zhJ";
var _2 = "njTAe";
export { _1 as "hidden", _2 as "messagePopup" }
